'use client'

import { useTranslations } from 'next-intl'

import JoinArenaArrow from '@/assets/icons/join-arena-arrow.svg'
import { URLS } from '@/configs/urls'
import { Link } from '@/i18n/routing'
import { useHydratedAuthUi } from '@/lib/react/useHydratedAuthUi'
import { useAuth } from '@/providers/AuthProvider'

import S from './FansHeroIntro.module.scss'

const FansHeroIntro = () => {
  const t = useTranslations('fansPage.hero')
  const hasHydratedAuthUi = useHydratedAuthUi()
  const { openAuthModal, isAuthenticated } = useAuth()
  // SSR and the first client paint must match: auth cookies exist only in the
  // browser, so gated CTAs wait for hydration before switching.
  const showAuthenticatedCta = hasHydratedAuthUi && isAuthenticated

  return (
    <>
      <p className={S.eyebrow}>{t('eyebrow')}</p>
      <h1 className={S.headline}>
        <span className={S.headlineWhite}>{t('headlineWhite')}</span>
        <span className={S.headlineAccent}>{t('headlineAccent')}</span>
      </h1>
      <p className={S.bodyLine}>
        {t('bodyLine1')}
        {'\u00A0'}
        {t('bodyLine2')}
      </p>
      <div className={S.ctaRow}>
        {!showAuthenticatedCta ? (
          <>
            {/* Guest: register as a fan, then a quiet link to the "platform"
                section on the home page (how the product works). */}
            <button
              type="button"
              className={S.joinCta}
              onClick={() =>
                openAuthModal('emailSignupEntityChoose', 'landing')
              }
            >
              <span className={S.joinCtaText}>{t('joinArena')}</span>
              <JoinArenaArrow className={S.joinCtaArrow} aria-hidden />
            </button>
            <Link href={URLS.PLATFORM_BLOCK} className={S.challengesLink}>
              <span className={S.challengesText}>{t('howItWorks')}</span>
            </Link>
          </>
        ) : (
          <>
            {/* Authenticated fan: straight to tasks, plus the fan leaderboard
                (URLS.LEADERBOARD defaults to the fans audience). */}
            <Link href={URLS.TASKS} className={S.joinCta}>
              <span className={S.joinCtaText}>{t('seeChallenges')}</span>
              <JoinArenaArrow className={S.joinCtaArrow} aria-hidden />
            </Link>
            <Link href={URLS.LEADERBOARD} className={S.challengesLink}>
              <span className={S.challengesText}>{t('leaderboard')}</span>
            </Link>
          </>
        )}
      </div>
    </>
  )
}

export default FansHeroIntro
